// =============== xAPI (TIN CAN API) ===============
// Experience API support with graceful degradation

let xapiConfig = null;

export function initXAPI(config) {
  if (!config || !config.endpoint || !config.auth) {
    return false;
  }
  xapiConfig = config;
  return true;
}

export function sendAttemptedStatement(assessmentId) {
  if (!xapiConfig) return Promise.resolve(false);
  
  const statement = {
    actor: xapiConfig.actor || { mbox: 'mailto:learner@example.com', name: 'Learner' },
    verb: { id: 'http://adlnet.gov/expapi/verbs/attempted', display: { 'en-US': 'attempted' } },
    object: {
      id: `${xapiConfig.activityId || 'http://example.com/assessment'}/${assessmentId}`,
      definition: { type: 'http://adlnet.gov/expapi/activities/assessment', name: { 'en-US': assessmentId } }
    },
    timestamp: new Date().toISOString()
  };
  
  return sendStatement(statement);
}

export function sendAnsweredStatement(questionId, answer) {
  if (!xapiConfig) return Promise.resolve(false);
  
  const statement = {
    actor: xapiConfig.actor || { mbox: 'mailto:learner@example.com', name: 'Learner' },
    verb: { id: 'http://adlnet.gov/expapi/verbs/answered', display: { 'en-US': 'answered' } },
    object: {
      id: `${xapiConfig.activityId || 'http://example.com/question'}/${questionId}`,
      definition: { type: 'http://adlnet.gov/expapi/activities/cmi.interaction' }
    },
    result: { response: String(answer) },
    timestamp: new Date().toISOString()
  };
  
  return sendStatement(statement);
}

export function sendCompletedStatement(score) {
  if (!xapiConfig) return Promise.resolve(false);
  
  const statement = {
    actor: xapiConfig.actor || { mbox: 'mailto:learner@example.com', name: 'Learner' },
    verb: { id: 'http://adlnet.gov/expapi/verbs/completed', display: { 'en-US': 'completed' } },
    object: {
      id: xapiConfig.activityId || 'http://example.com/assessment',
      definition: { type: 'http://adlnet.gov/expapi/activities/assessment' }
    },
    result: { score: { scaled: score / 100, raw: score, min: 0, max: 100 }, completion: true, success: score >= 70 },
    timestamp: new Date().toISOString()
  };
  
  return sendStatement(statement);
}

function sendStatement(statement) {
  if (!xapiConfig) return Promise.resolve(false);
  
  try {
    return fetch(`${xapiConfig.endpoint}/statements`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': xapiConfig.auth,
        'X-Experience-API-Version': '1.0.3'
      },
      body: JSON.stringify(statement)
    })
    .then(res => res.ok)
    .catch(error => {
      console.warn('xAPI statement failed:', error.message);
      return false;
    });
  } catch (error) {
    console.warn('xAPI send failed:', error.message);
    return Promise.resolve(false);
  }
}
